import React, { useState } from 'react';
import { useTranslation } from '../i18n';
import closeButton from '../images/close-line-white.svg';
import icon from './../images/sunrise-line.svg';
import { analytics } from '../firebaseConfig';
import { logEvent } from 'firebase/analytics';

const ChangeTheme = ({ theme, handleThemeChange }) => {
  const { t } = useTranslation();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  function openModal() {
    setModalIsOpen(true);
  }
  function closeModal() {
    setModalIsOpen(false);
  }

  function handleClick(selection) {
    handleThemeChange(selection);
    logEvent(analytics, 'account_settings_theme', { theme: selection });
    closeModal();
  }

  return [
    <div className="row-item" key="item-row">
      <img height={24} width={24} alt="Change theme" src={icon} />
      <div
        className="link"
        onClick={() => openModal()}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            openModal();
          }
        }}
        tabIndex={0}
      >
        {t.changetheme}
      </div>
      <div className="pt-65 fs-s flex-grow align-right">{t.theme[theme]}</div>
    </div>,
    modalIsOpen && (
      <div className="overlay" key="overlay">
        <div className="buttons-wrapper">
          <div className="buttons-header">
            <span>{t.changetheme}</span>
            <button className="btn-icon" onClick={closeModal}>
              <img
                className="icon"
                src={closeButton}
                width={24}
                height={24}
                alt="Close icon"
              />
            </button>
          </div>
          <div className="separator"></div>
          <div className="buttons">
            <button
              className="btn btn-secondary"
              onClick={() => handleClick('light')}
            >
              {t.theme.light}
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => handleClick('dark')}
            >
              {t.theme.dark}
            </button>
          </div>
        </div>
      </div>
    ),
  ];
};

export default ChangeTheme;
